export default __webpack_public_path__ + "static/media/cadillac.ddf7696f.svg";